import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectHomeState = (state: AppState) =>
  state.home;


export const selectSupportTabIndex = createSelector(
  selectHomeState,
  (state) => state.supportTabIndex
);
export const selectScenariosTabIndex = createSelector(
  selectHomeState,
  (state) => state.scenariosTabIndex
);
export const selectPermissionsTabIndex = createSelector(
  selectHomeState,
  (state) => state.permissionsTabIndex
);
export const selectDeviceTabIndex = createSelector(
  selectHomeState,
  (state) => state.deviceTabIndex
);

